<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items" />
        <b-card>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label
                  class="col-form-label col-form-label-sm"
                  for="household_number"
                  >Household Number</label
                >
                <input
                  v-model="search_data.household_number"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Search by HH No"
                  id="household_number"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="ep_id"
                  >EP ID</label
                >
                <input
                  v-model="search_data.ep_id"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Search by EP ID"
                  id="ep_id"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="gender_id"
                  >Gender</label
                >
                <select
                  v-model="search_data.gender_id"
                  class="form-control form-control-sm"
                  name="gender_id"
                  id="gender_id"
                >
                  <option selected :value="''">Select a Gender</option>
                  <option
                    v-for="(gender, index) in genders"
                    :key="index"
                    :value="gender.id"
                    >{{ gender.id }} : {{ gender.gender_desc }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-row mt-1">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label
                  class="col-form-label col-form-label-sm"
                  for="district_id"
                  >District</label
                >
                <select
                  v-model="search_data.district_id"
                  class="form-control form-control-sm"
                  name="district_id"
                  id="district_id"
                >
                  <option selected :value="''">Select a District</option>
                  <option
                    v-for="(district, index) in districts"
                    :key="index"
                    :value="district.id"
                    >{{ district.id }} : {{ district.district_desc }}</option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="mouza_id"
                  >Mouza</label
                >
                <select
                  v-model="search_data.mouza_id"
                  class="form-control form-control-sm"
                  name="mouza_id"
                  id="mouza_id"
                >
                  <option selected :value="''">Select a mouza</option>
                  <option
                    v-for="(mouza, index) in mouzas"
                    :key="index"
                    :value="mouza.id"
                    >{{ mouza.id }} : {{ mouza.mouza_desc }}</option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="village_id"
                  >Village</label
                >
                <select
                  v-model="search_data.village_id"
                  class="form-control form-control-sm"
                  name="village_id"
                  id="village_id"
                >
                  <option selected :value="''">Select a village</option>
                  <option
                    v-for="(village, index) in villages"
                    :key="index"
                    :value="village.id"
                    >{{ village.id }} : {{ village.village_desc }}</option
                  >
                </select>
              </div>
            </div>
            <button
              class="btn btn-success btn-sm mt-2"
              @click.prevent="search()"
              >Search</button
            >
          </form>
        </b-card>

        <b-card>
          <div class="row mb-2" v-if="seses">
            <div class="col-sm-4">
              <span class="badge badge-success"
                >Total Search Data Found: {{ seses.total }}</span
              >
            </div>
          </div>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
                <tr>
                  <th>Sl</th>
                  <th>EP ID</th>
                  <th>EP Name</th>
                  <th>Father's Name</th>
                  <th>Gender</th>
                  <th>Mouza</th>
                  <th>District</th>
                  <th>Amount Paid(BDT)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ses, index) in seses.data" :key="index">
                  <td>{{ seses.from + index }}</td>
                  <td>{{
                    epIdWithPaymentStatus(ses.ep_id.ep_id, ses.ep_id.is_paid)
                  }}</td>
                  <td>
                    <router-link
                      :to="{ name: 'sesView', params: { ses_id: ses.id } }"
                      tag="a"
                      target="_blank"
                      >{{ ses.name }}</router-link
                    >
                  </td>
                  <td>{{ ses.father_husband_name }}</td>
                  <td>{{ ses.gender.gender_desc }}</td>
                  <td>{{ ses.mouza.mouza_desc }}</td>
                  <td>{{ ses.district.district_desc }}</td>
                  <td>{{ ses.total_amount }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="loader" class="loader">Loading...</div>
            <h5
              class="text-center text-secondary"
              v-if="seses.total === 0 || !flag"
            >
              No Data Found
            </h5>
            <div class="float-right mt-1">
              <pagination
                :data="seses"
                :limit="2"
                @pagination-change-page="getResults"
              ></pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'
import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

export default {
  page: {
    title: 'List SES',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Search SES',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'SES',
          active: true,
        },
      ],
      seses: {},
      search_data: {
        household_number: '',
        ep_id: '',
        village_id: '',
        mouza_id: '',
        district_id: '',
        gender_id: '',
      },
      genders: [],
      districts: [],
      all_upazilas: [],
      all_unions: [],
      all_mouzas: [],
      all_villages: [],
      flag: false,
      loader: false,
    }
  },

  mounted() {
    this.search_data.ep_type = this.$route.params.ep_type
    this.search_data.district_id = this.$route.params.district_id
    this.getCodes()
  },
  methods: {
    epIdWithPaymentStatus: epIdWithPaymentStatus,
    getCodes() {
      http.get('api/ses/codes').then((response) => {
        if (!response.error) {
          let data = response.data
          this.genders = data.genders
          this.districts = data.districts
          this.all_upazilas = data.upazillas
          this.all_unions = data.unions
          this.all_mouzas = data.mouzas
          this.all_villages = data.villages
        }
      })
    },
    search() {
      this.flag = true
      this.loader = true
      http
        .post('api/vulnerable/view/search', this.search_data)
        .then((response) => {
          if (!response.error) {
            this.flag = true
            this.loader = false
            this.seses = response.data.seses
          }
        })
    },
    getResults(page = 1) {
      this.flag = true
      this.loader = true
      http
        .post('api/vulnerable/view/search?page=' + page, this.search_data)
        .then((response) => {
          this.flag = true
          this.loader = false
          this.seses = response.data.seses
        })
    },
  },
  computed: {
    userPermission() {
      return this.$store.state.user
    },
    mouzas() {
      const district_id = Number.parseInt(this.search_data.district_id)
      const filterUpazila = district_id
        ? this.all_upazilas.filter((x) => x.district_id === district_id)
        : null
      const filterUnion = []
      if (filterUpazila) {
        filterUpazila.forEach((value, index) => {
          const upazila_id = value.id
          const union = upazila_id
            ? this.all_unions.filter((x) => x.upazila_id === upazila_id)
            : null
          filterUnion.push(union)
        })
      }
      const filterUnionResult = filterUnion.reduce(
        (r, e) => (r.push(...e), r),
        []
      )
      const filterMouza = []
      if (filterUnionResult) {
        filterUnionResult.forEach((value, index) => {
          const union_id = value.id
          const mouza = union_id
            ? this.all_mouzas.filter((x) => x.union_id === union_id)
            : null
          filterMouza.push(mouza)
        })
      }
      return filterMouza.reduce((r, e) => (r.push(...e), r), [])
    },
    villages() {
      const mouza_id = this.search_data.mouza_id
      return mouza_id
        ? this.all_villages.filter((x) => x.mouza_id === mouza_id)
        : null
    },
  },
  created() {
    this.$store.dispatch('getUserPermission')
  },
}
</script>
<style src="vue-select/dist/vue-select.css"></style>
